import { all } from 'redux-saga/effects'
import auth from './auth'
import user from './user'
import content from './content'
import customer from './customer'
import customContentType from './custom-content-type'
import statics from './statics'
import responsible from './responsible'
import inspection from './inspection'
import periodicCheck from './periodic-check'
import company from './company'
import element from './element'
import license from './license'
import invitation from './invitation'
import contact from './contact'
import notification from './notification'
import enargas from './enargas'

export default function* rootSaga() {
  yield all([
    auth(),
    user(),
    content(),
    customContentType(),
    customer(),
    statics(),
    responsible(),
    inspection(),
    periodicCheck(),
    company(),
    element(),
    license(),
    invitation(),
    contact(),
    notification(),
    enargas()
  ])
}
